import { request } from '@/api/http';
import type { BuildInfo, DashboardSummary, DiagnosticsData, HealthData, RuntimeInfo, TelegramSendResult } from '@/api/types';

export const dashboardService = {
  health: () => request<HealthData>('/dashboard/health'),
  summary: (opts?: { signal?: AbortSignal }) =>
    request<DashboardSummary>('/dashboard/summary', opts),
  diagnostics: (opts?: { signal?: AbortSignal }) =>
    request<DiagnosticsData>('/dashboard/diagnostics', opts),
  runtimeInfo: () => request<RuntimeInfo>('/runtime/info'),
  buildInfo: () => request<BuildInfo>('/build-info', { skipAuth: true }),
};

export type TelegramKnownChatsResult = {
  updates: {
    chat_id: number;
    username?: string | null;
    first_name?: string | null;
    source?: string | null;
    access_hash?: number | null;
    entity_type?: string | null;
  }[];
  message?: string | null;
  cached?: boolean;
  refreshing?: boolean;
  last_refreshed_at?: string | null;
  error_code?: string | null;
  source?: string | null;
  messageCode?: string | null;
};

export const telegramService = {
  status: () =>
    request<{
      session_exists: boolean;
      session_path: string;
      bot_token_configured: boolean;
      api_id_configured: boolean;
      api_hash_configured: boolean;
      sender_mode: string;
      sender_mode_configured: boolean;
    }>('/telegram/status'),
  send: (body: {
    message: string;
    user_id?: string;
    user_ids?: string[];
    telegram_chat_id?: string;
    send_to_all_enabled?: boolean;
  }) => request<TelegramSendResult>('/telegram/send', { method: 'POST', body: JSON.stringify(body) }),
  updates: () => request<TelegramKnownChatsResult>('/telegram/updates'),
  refreshKnownChats: () =>
    request<TelegramKnownChatsResult>('/telegram/known-chats/refresh', { method: 'POST' }),
};
